import type { Dispatch } from 'react';

import type { ContextState } from '../../../types';
import { ECustomerTypeSelection } from '../../../types';

export function useCustomerValidation<D>([prevState, dispatch]: [ContextState, Dispatch<D>]): [
  ContextState,
  Dispatch<D>,
] {
  const { newCustomer, existingCustomer, selectedCustomerType } = prevState;
  let isCustomerSelectionValid = Boolean(selectedCustomerType);
  if (selectedCustomerType === ECustomerTypeSelection.ExistingCustomer) {
    isCustomerSelectionValid = Boolean(
      (Boolean(existingCustomer) || (newCustomer?.firstName && newCustomer.surname)) &&
        !(Boolean(existingCustomer) && (Boolean(newCustomer?.firstName) || Boolean(newCustomer?.surname))),
    );
  }

  return [
    {
      ...prevState,
      isCustomerSelectionValid,
    },
    dispatch,
  ];
}
